<template>
  <div style="position: relative;">
    <el-form ref="UserWorkDraftListFilter" :model="UserWorkDraftList" :size="defaultFormItemSize"
             label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="状态" prop="formFilter.status">
          <el-select class="filter-item" v-model="UserWorkDraftList.formFilter.status" :clearable="true" filterable
                     placeholder="状态" :loading="UserWorkDraftList.status.impl.loading"
                     @visible-change="UserWorkDraftList.status.impl.onVisibleChange">
            <el-option v-for="item in UserWorkDraftList.status.impl.dropdownList" :key="item.id" :value="item.id"
                       :label="item.name"/>
          </el-select>
        </el-form-item>
        <el-form-item label="稿件名称" prop="formFilter.workName">
          <el-input class="filter-item" v-model="UserWorkDraftList.formFilter.workName"
                    :clearable="true" placeholder="请输入参与作品名称"
          />
        </el-form-item>
        <el-form-item label="人员名称" prop="formFilter.userName">
          <el-input class="filter-item" v-model="UserWorkDraftList.formFilter.userName"
                    :clearable="true" placeholder="请输入参与人员名称"
          />
        </el-form-item>
        <!--
                <el-form-item label="大类名称(原始)" prop="formFilter.workBigTypeName">
                  <el-input class="filter-item" v-model="UserWorkDraftList.formFilter.workBigTypeName"
                    :clearable="true" placeholder="大类名称"
                  />
                </el-form-item>
        -->
        <!-- ziyi 2022年6月11日 -->
        <el-form-item label="部门" prop="formFilter.bumenmingcheng">
          <el-select class="filter-item" v-model="UserWorkDraftList.formFilter.bumenmingcheng" :clearable="true"
                     filterable
                     placeholder="选择部门" :loading="UserWorkDraftList.daleimingchengLv.impl.loading"
                     @visible-change="UserWorkDraftList.daleimingchengLv.impl.onVisibleChange"
                     @change="onAssessLvValueChange">
            <el-option v-for="item in UserWorkDraftList.daleimingchengLv.impl.dropdownList" :key="item.id"
                       :value="item.id" :label="item.name"/>
          </el-select>
        </el-form-item>
        <!-- ziyi 2022年6月11日 end-->
        <!--
                <el-form-item label="作品类型名称（原始）" prop="formFilter.workTypeName">
                  <el-input class="filter-item" v-model="UserWorkDraftList.formFilter.workTypeName"
                    :clearable="true" placeholder="作品类型名称"
                  />
                </el-form-item>
        -->
        <!-- ziyi 2022年6月11日 -->
        <el-form-item label="稿件类型" prop="formFilter.zuopinleixingmingceng">
          <el-select class="filter-item" v-model="UserWorkDraftList.formFilter.zuopinleixingmingceng" :clearable="true"
                     filterable
                     placeholder="选择稿件类型" :loading="UserWorkDraftList.zuopinleixingmingchengLv.impl.loading"
                     @visible-change="UserWorkDraftList.zuopinleixingmingchengLv.impl.onVisibleChange"
                     @change="onAssessLvValueChange">
            <el-option v-for="item in UserWorkDraftList.zuopinleixingmingchengLv.impl.dropdownList" :key="item.id"
                       :value="item.id" :label="item.name"/>
          </el-select>
        </el-form-item>
        <!--
        <el-form-item label="得分" prop="formFilter.score">
          <input-number-range class="filter-item"
            v-model="UserWorkDraftList.formFilter.score" :clearable="true"
            startPlaceholder="最小值" endPlaceholder="最大值"
          />
        </el-form-item>-->
        <el-form-item label="开始时间" prop="formFilter.language">
          <div class="block">
            <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" class="filter-item"
                            v-model="UserWorkDraftList.formFilter.kaishishijian" type="date" placeholder="选择开始日期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="结束时间" prop="formFilter.language">
          <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" class="filter-item"
                          v-model="UserWorkDraftList.formFilter.jiesushijian" type="date" placeholder="选择结束日期">
          </el-date-picker>
        </el-form-item>
        <!-- ziyi 2022年6月11日 end -->
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize"
                   @click="onResetUserWorkDraftList">重置
        </el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="onExportClick()">
          导出
        </el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize"
                   @click="refreshUserWorkDraftList(true)">查询
        </el-button>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="paWorkDraft" :data="UserWorkDraftList.PaWorkDraft.impl.dataList" :size="defaultFormItemSize"
                  @sort-change="UserWorkDraftList.PaWorkDraft.impl.onSortChange"
                  header-cell-class-name="table-header-gray" height="600px"
                  highlight-current-row @current-change="UserWorkDraftList.PaWorkDraft.impl.currentRowChange"
        >
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px"
                           :index="UserWorkDraftList.PaWorkDraft.impl.getTableIndex"/>
          <el-table-column label="状态" prop="statusDictMap.name">
          </el-table-column>
          <el-table-column label="稿件名称" prop="workName" width="150px">
          </el-table-column>
          <el-table-column label="稿件类型" prop="workBigTypeName" width="150px">
          </el-table-column>
          <el-table-column label="采用级别" prop="workTypeName" width="150px">
          </el-table-column>
          <el-table-column label="采用稿件比例" prop="deptPostName">
          </el-table-column>
          <el-table-column label="部门名称" prop="deptName">
          </el-table-column>
          <el-table-column label="上传时间" prop="createTime" width="150px">
          </el-table-column>
          <el-table-column label="员工姓名" prop="userName">
          </el-table-column>
          <el-table-column label="评审人" prop="assessUserIdDictMap.name">
          </el-table-column>
          <el-table-column label="评审时间" prop="updateTime" width="100px">
            <template slot-scope="scope">
              <span>{{ formatDateByStatsType(scope.row.updateTime, 'day') }}</span>
            </template>
          </el-table-column>
          <el-table-column label="奖励金额" prop="score">
          </el-table-column>
          <el-table-column label="稿件描述" prop="workDetail" width="450px">
          </el-table-column>
          <el-table-column label="比例评价" prop="assessDetail" width="250px">
          </el-table-column>
          <el-table-column label="采用链接" prop="workUrl">
            <template slot-scope="scope">
              <a v-if="scope.row.workUrl" :href="scope.row.workUrl" target="view_window">点击访问</a>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="110px">
            <template slot-scope="scope">
              <el-button @click.stop="onDeleteClick(scope.row)" type="text" :size="defaultFormItemSize"
                         v-if="scope.row.type!=='root'"
              >
                删除
              </el-button>
              <el-button @click="onUpdateWorkClick(scope.row)" type="text" :size="defaultFormItemSize"
                         v-if="scope.row.type!=='post'"
              >
                修改{{ scope.row.type === 'root' ? '类型' : scope.row.type === 'big_type' ? '级别' : scope.row.type === 'type' ? '比例' : '' }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="UserWorkDraftList.PaWorkDraft.impl.totalCount"
            :current-page="UserWorkDraftList.PaWorkDraft.impl.currentPage"
            :page-size="UserWorkDraftList.PaWorkDraft.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="UserWorkDraftList.PaWorkDraft.impl.onCurrentPageChange"
            @size-change="UserWorkDraftList.PaWorkDraft.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close"/>
    </label>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import {findTreeNode, findTreeNodePath, findItemFromList} from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import {DropdownWidget, TableWidget, UploadWidget, ChartWidget} from '@/utils/widget.js';
/* eslint-disable-next-line */
import {uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin} from '@/core/mixins';
/* eslint-disable-next-line */
import {DictionaryController, PaWorkDraftController, PaWorkLvMoneyController, PaWorkLvScoreController} from '@/api';

import updateWorkLvMoney from '@/views/WorkManage/editWorkDraft.vue';

export default {
  name: 'UserWorkDraftList',
  props: {
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data() {
    return {
      UserWorkDraftList: {
        formFilter: {
          status: undefined,
          workName: undefined,
          workBigTypeName: undefined,
          workTypeName: undefined,
          assessLv: undefined,
          score: [],
          language: undefined,
          kaishishijian: undefined,
          jiesushijian: undefined,
          zuopinleixingmingceng: undefined,
          bumenmingcheng: undefined,
          userName: undefined
        },
        formFilterCopy: {
          status: undefined,
          workName: undefined,
          workBigTypeName: undefined,
          workTypeName: undefined,
          assessLv: undefined,
          score: [],
          language: undefined,
          kaishishijian: undefined,
          jiesushijian: undefined,
          zuopinleixingmingceng: undefined,
          bumenmingcheng: undefined,
          userName: undefined
        },
        PaWorkDraft: {
          impl: new TableWidget(this.loadPaWorkDraftWidgetData, this.loadPaWorkDraftVerify, true, true, 'updateTime', 0)
        },
        assessLv: {
          impl: new DropdownWidget(this.loadAssessLvDropdownList)
        },
        daleimingchengLv: {
          impl: new DropdownWidget(this.loaddaleimingchengLvDropdownList)
        },
        zuopinleixingmingchengLv: {
          impl: new DropdownWidget(this.loadzuopinleixingmingchengLvDropdownList)
        },
        status: {
          impl: new DropdownWidget(this.loadStatusDropdownList)
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel(isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    onResetUserWorkDraftList() {
      this.$refs.UserWorkDraftListFilter.resetFields();
      this.refreshUserWorkDraftList(true);
    },
    /**
     * 作品行数据获取函数，返回Promise
     */
    loadPaWorkDraftWidgetData(params) {
      if (params == null) params = {};

      if (this.UserWorkDraftList.formFilterCopy.kaishishijian && this.UserWorkDraftList.formFilterCopy.jiesushijian) {
        if (new Date(this.UserWorkDraftList.formFilterCopy.kaishishijian).getTime() > new Date(this.UserWorkDraftList.formFilterCopy.jiesushijian).getTime()) {
          this.$message.error('操作失败!开始时间 不能大于 结束时间!');
          return;
        }
      }
      params = {
        ...params,
        paWorkDraftDtoFilter: {
          status: this.UserWorkDraftList.formFilterCopy.status,
          workName: this.UserWorkDraftList.formFilterCopy.workName,
          kaishishijian: this.UserWorkDraftList.formFilterCopy.kaishishijian,
          jiesushijian: this.UserWorkDraftList.formFilterCopy.jiesushijian,
          zuopinleixingmingceng: this.UserWorkDraftList.formFilterCopy.zuopinleixingmingceng,
          bumenmingcheng: this.UserWorkDraftList.formFilterCopy.bumenmingcheng,
          userName: this.UserWorkDraftList.formFilterCopy.userName
        }
      }
      return new Promise((resolve, reject) => {
        PaWorkDraftController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.UserWorkDraftList.PaWorkDraft.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.UserWorkDraftList.PaWorkDraft.impl.currentRow.id, 'id');
              this.$refs.paWorkDraft.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 作品行数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadPaWorkDraftVerify() {
      this.UserWorkDraftList.formFilterCopy.status = this.UserWorkDraftList.formFilter.status;
      this.UserWorkDraftList.formFilterCopy.workName = this.UserWorkDraftList.formFilter.workName;
      this.UserWorkDraftList.formFilterCopy.kaishishijian = this.UserWorkDraftList.formFilter.kaishishijian;
      this.UserWorkDraftList.formFilterCopy.jiesushijian = this.UserWorkDraftList.formFilter.jiesushijian;
      this.UserWorkDraftList.formFilterCopy.zuopinleixingmingceng = this.UserWorkDraftList.formFilter.zuopinleixingmingceng;
      this.UserWorkDraftList.formFilterCopy.bumenmingcheng = this.UserWorkDraftList.formFilter.bumenmingcheng;
      this.UserWorkDraftList.formFilterCopy.userName = this.UserWorkDraftList.formFilter.userName;
      return true;
    },
    /**
     * 作品评级下拉数据获取函数
     */
    loadAssessLvDropdownList() {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_work_assess_lv'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
    *部门名称下拉选择器
     */
    loaddaleimingchengLvDropdownList() {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSysDictDaLeiMingCheng(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     *作品类型名称
      */
    loadzuopinleixingmingchengLvDropdownList() {
      return new Promise((resolve, reject) => {
        let params = {type: 'big_type'};
        DictionaryController.dictSysWorkDraft(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 作品评级下拉数据获取函数
     */
    loadStatusDropdownList() {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_work_status'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 作品评级选中值改变
     */
    onAssessLvValueChange(value) {
      // console.log("value-->" + value)
    },
    /**
     * 更新人员作品列表
     */
    refreshUserWorkDraftList(reloadData = false) {
      if (reloadData) {
        this.UserWorkDraftList.PaWorkDraft.impl.refreshTable(true, 1);
      } else {
        this.UserWorkDraftList.PaWorkDraft.impl.refreshTable();
      }
      if (!this.UserWorkDraftList.isInit) {
        // 初始化下拉数据
      }
      this.UserWorkDraftList.isInit = true;
    },
    /**
     * 导出
     */
    onExportClick() {
      this.loadPaWorkDraftVerify();
      if (this.UserWorkDraftList.formFilterCopy.kaishishijian && this.UserWorkDraftList.formFilterCopy.jiesushijian) {
        if (new Date(this.UserWorkDraftList.formFilterCopy.kaishishijian).getTime() > new Date(this.UserWorkDraftList.formFilterCopy.jiesushijian).getTime()) {
          this.$message.error('操作失败!开始时间 不能大于 结束时间!');
          return;
        }
      }
      let params = {};
      params = {
        paWorkDraftDtoFilter: {
          status: this.UserWorkDraftList.formFilterCopy.status,
          workName: this.UserWorkDraftList.formFilterCopy.workName,
          kaishishijian: this.UserWorkDraftList.formFilterCopy.kaishishijian,
          jiesushijian: this.UserWorkDraftList.formFilterCopy.jiesushijian,
          zuopinleixingmingceng: this.UserWorkDraftList.formFilterCopy.zuopinleixingmingceng,
          bumenmingcheng: this.UserWorkDraftList.formFilterCopy.bumenmingcheng,
          userName: this.UserWorkDraftList.formFilterCopy.userName
        }
        //, ...params
      }
      PaWorkDraftController.export(this, params, '稿件记录.xlsx').then(res => {
        this.$message.success('导出成功');
      }).catch(e => {
        this.$message.error(e.errorMessage);
      });
    },
    /**
     * 删除
     */
    onDeleteClick(row) {
      if (row.pid === -1) {
        this.$message.error('删除失败!根节点不能删除!');
        return;
      }
      if (row.children !== undefined && row.children.length > 0) {
        this.$message.error('删除失败!请先删除子项!');
        return;
      }
      let params = {
        id: row.id
      };

      this.$confirm('是否删除?').then(res => {
        PaWorkDraftController.delete(this, params).then(res => {
          this.$message.success('删除成功');
          this.UserWorkDraftList.PaWorkDraft.impl.refreshTable();
        }).catch(e => {
        });
      }).catch(e => {
      });
    },
    /**
     * 添加
     */
    onUpdateWorkClick(row) {
      row = (row || this.UserWorkDraftList.PaWorkDraft.impl.currentRow || {});
      let params = {
        id: row.id
      };

      this.$dialog.show('修改', updateWorkLvMoney, {
        area: '400px'
      }, params).then(res => {
        this.refreshUserWorkDraftList();
      }).catch(e => {
      });
    },
    onResume() {
      this.refreshUserWorkDraftList();
    },
    initFormData() {
    },
    formInit() {
      this.refreshUserWorkDraftList();
    }
  },
  mounted() {
    // 初始化页面数据
    this.formInit();
  },
  watch: {}
}
</script>
